import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationConfig } from '../data/navigationData';
import { trackButtonClick } from '../../../utils/analytics';

const JoinButton = ({ variant, className = '' }) => {
  const { joinButton } = navigationConfig;
  const location = useLocation();
  
  const handleClick = () => {
    trackButtonClick('join_us', location.pathname);
  };
  
  return (
    <Link 
      to={joinButton.path} 
      className={`join-button ${className}`}
      onClick={handleClick}
    >
      {joinButton.label}
    </Link>
  );
};

export default JoinButton;